import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "card-detail-pdf" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-5 mb-xl-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "List Highlight PDF")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body py-3" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://archive.kurasi.media/siputra/file/20220526171931.pdf",
      style: {"width":"718px","height":"700px"},
      frameborder: "0"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}